export default [
  {
    component: 'TitleText',
    data: {
      // title: 'chapter-3.slice-1.title',
      text: 'chapter-5.slice-0.description',
    }
  },
  {
    component: "Product",
    data: {
      title: "chapter-5.slice-1.title",
      name: "chapter-5.slice-1.name",
      description: "chapter-5.slice-1.description",
      cta: "chapter-5.slice-1.url",
      ctaLabel: "chapter-5.slice-1.cta_label",
      visuals: [
        {
          image: {
            alt: "chapter-5.slice-1.image-1.full.alt",
            src: "chapter-5.slice-1.image-1.full.src",
            // src: require('@/assets/images/chapter-5_slice-1_visual-1.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-1.image-1.thumbnail.alt",
            src: "chapter-5.slice-1.image-1.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-1_visual-1.jpg')
          },
        }, {
          image: {
            alt: "chapter-5.slice-1.image-2.full.alt",
            src: "chapter-5.slice-1.image-2.full.src",
            // src: require('@/assets/images/chapter-5_slice-1_visual-2.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-1.image-2.thumbnail.alt",
            src: "chapter-5.slice-1.image-2.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-1_visual-2.jpg')
          },
          video: {
            mp4: require('@/assets/videos/chapter-5_slice-1_visual-2.mp4'),
            webm: require('@/assets/videos/chapter-5_slice-1_visual-2.webm'),
          }
        }, {
          image: {
            alt: "chapter-5.slice-1.image-3.full.alt",
            src: "chapter-5.slice-1.image-3.full.src",
            // src: require('@/assets/images/chapter-5_slice-1_visual-3.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-1.image-3.thumbnail.alt",
            src: "chapter-5.slice-1.image-3.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-1_visual-3.jpg')
          }
        }, {
          image: {
            alt: "chapter-5.slice-1.image-4.full.alt",
            src: "chapter-5.slice-1.image-4.full.src",
            // src: require('@/assets/images/chapter-5_slice-1_visual-4.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-1.image-4.thumbnail.alt",
            src: "chapter-5.slice-1.image-4.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-1_visual-4.jpg')
          },
          video: {
            mp4: require('@/assets/videos/chapter-5_slice-1_visual-4.mp4'),
            webm: require('@/assets/videos/chapter-5_slice-1_visual-4.webm'),
          }
        }
      ]
    }
  },
  {
    component: "Product",
    data: {
      name: "chapter-5.slice-2.name",
      description: "chapter-5.slice-2.description",
      cta: "chapter-5.slice-2.url",
      ctaLabel: "chapter-5.slice-2.cta_label",
      title: "chapter-5.slice-2.title",
      visuals: [
        {
          image: {
            alt: "chapter-5.slice-2.image-1.full.alt",
            src: "chapter-5.slice-2.image-1.full.src",
            // src: require('@/assets/images/chapter-5_slice-2_visual-1.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-2.image-1.thumbnail.alt",
            src: "chapter-5.slice-2.image-1.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-2_visual-1.jpg')
          }
        }, {
          image: {
            alt: "chapter-5.slice-2.image-2.full.alt",
            src: "chapter-5.slice-2.image-2.full.src",
            // src: require('@/assets/images/chapter-5_slice-2_visual-2.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-2.image-2.thumbnail.alt",
            src: "chapter-5.slice-2.image-2.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-2_visual-2.jpg')
          },
          video: {
            mp4: require('@/assets/videos/chapter-5_slice-2_visual-2.mp4'),
            webm: require('@/assets/videos/chapter-5_slice-2_visual-2.webm'),
          }
        }, {
          image: {
            alt: "chapter-5.slice-2.image-3.full.alt",
            src: "chapter-5.slice-2.image-3.full.src",
            // src: require('@/assets/images/chapter-5_slice-2_visual-3.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-2.image-3.thumbnail.alt",
            src: "chapter-5.slice-2.image-3.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-2_visual-3.jpg')
          }
        }, {
          image: {
            alt: "chapter-5.slice-2.image-4.full.alt",
            src: "chapter-5.slice-2.image-4.full.src",
            // src: require('@/assets/images/chapter-5_slice-2_visual-4.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-2.image-4.thumbnail.alt",
            src: "chapter-5.slice-2.image-4.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-2_visual-4.jpg')
          }
        }
      ]
    }
  },
  {
    component: "Product",
    data: {
      title: "chapter-5.slice-3.title",
      name: "chapter-5.slice-3.name",
      description: "chapter-5.slice-3.description",
      cta: "chapter-5.slice-3.url",
      ctaLabel: "chapter-5.slice-3.cta_label",
      visuals: [
        {
          image: {
            alt: "chapter-5.slice-3.image-1.full.alt",
            src: "chapter-5.slice-3.image-1.full.src",
            // src: require('@/assets/images/chapter-5_slice-3_visual-1.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-3.image-1.thumbnail.alt",
            src: "chapter-5.slice-3.image-1.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-3_visual-1.jpg')
          }
        }, {
          image: {
            alt: "chapter-5.slice-3.image-2.full.alt",
            src: "chapter-5.slice-3.image-2.full.src",
            // src: require('@/assets/images/chapter-5_slice-3_visual-2.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-3.image-2.thumbnail.alt",
            src: "chapter-5.slice-3.image-2.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-3_visual-2.jpg')
          }
        }, {
          image: {
            alt: "chapter-5.slice-3.image-3.full.alt",
            src: "chapter-5.slice-3.image-3.full.src",
            // src: require('@/assets/images/chapter-5_slice-3_visual-3.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-3.image-3.thumbnail.alt",
            src: "chapter-5.slice-3.image-3.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-3_visual-3.jpg')
          }
        }, {
          image: {
            alt: "chapter-5.slice-3.image-4.full.alt",
            src: "chapter-5.slice-3.image-4.full.src",
            // src: require('@/assets/images/chapter-5_slice-3_visual-4.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-3.image-4.thumbnail.alt",
            src: "chapter-5.slice-3.image-4.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-3_visual-4.jpg')
          }
        }
      ]
    }
  },
  {
    component: "Product",
    data: {
      title: "chapter-5.slice-4.title",
      name: "chapter-5.slice-4.name",
      description: "chapter-5.slice-4.description",
      cta: "chapter-5.slice-4.url",
      ctaLabel: "chapter-5.slice-4.cta_label",
      visuals: [
        {
          image: {
            alt: "chapter-5.slice-4.image-1.full.alt",
            src: "chapter-5.slice-4.image-1.full.src",
            // src: require('@/assets/images/chapter-5_slice-4_visual-1.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-4.image-1.thumbnail.alt",
            src: "chapter-5.slice-4.image-1.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-4_visual-1.jpg')
          }
        }, {
          image: {
            alt: "chapter-5.slice-4.image-2.full.alt",
            src: "chapter-5.slice-4.image-2.full.src",
            // src: require('@/assets/images/chapter-5_slice-4_visual-2.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-4.image-2.thumbnail.alt",
            src: "chapter-5.slice-4.image-2.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-4_visual-2.jpg')
          }
        }, {
          image: {
            alt: "chapter-5.slice-4.image-3.full.alt",
            src: "chapter-5.slice-4.image-3.full.src",
            // src: require('@/assets/images/chapter-5_slice-4_visual-3.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-4.image-3.thumbnail.alt",
            src: "chapter-5.slice-4.image-3.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-4_visual-3.jpg')
          }
        }, {
          image: {
            alt: "chapter-5.slice-4.image-4.full.alt",
            src: "chapter-5.slice-4.image-4.full.src",
            // src: require('@/assets/images/chapter-5_slice-4_visual-4.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-4.image-4.thumbnail.alt",
            src: "chapter-5.slice-4.image-4.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-4_visual-4.jpg')
          },
          video: {
            mp4: require('@/assets/videos/chapter-5_slice-4_visual-4.mp4'),
            webm: require('@/assets/videos/chapter-5_slice-4_visual-4.webm'),
          }
        }
      ]
    }
  },
  {
    component: "Product",
    data: {
      title: "chapter-5.slice-5.title",
      name: "chapter-5.slice-5.name",
      description: "chapter-5.slice-5.description",
      cta: "chapter-5.slice-5.url",
      ctaLabel: "chapter-5.slice-5.cta_label",
      visuals: [
        {
          image: {
            alt: "chapter-5.slice-5.image-1.full.alt",
            src: "chapter-5.slice-5.image-1.full.src",
            // src: require('@/assets/images/chapter-5_slice-5_visual-1.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-5.image-1.thumbnail.alt",
            src: "chapter-5.slice-5.image-1.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-5_visual-1.jpg')
          }
        }, {
          image: {
            alt: "chapter-5.slice-5.image-2.full.alt",
            src: "chapter-5.slice-5.image-2.full.src",
            // src: require('@/assets/images/chapter-5_slice-5_visual-2.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-5.image-2.thumbnail.alt",
            src: "chapter-5.slice-5.image-2.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-5_visual-2.jpg')
          }
        }, {
          image: {
            alt: "chapter-5.slice-5.image-3.full.alt",
            src: "chapter-5.slice-5.image-3.full.src",
            // src: require('@/assets/images/chapter-5_slice-5_visual-3.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-5.image-3.thumbnail.alt",
            src: "chapter-5.slice-5.image-3.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-5_visual-3.jpg')
          }
        }, {
          image: {
            alt: "chapter-5.slice-5.image-4.full.alt",
            src: "chapter-5.slice-5.image-4.full.src",
            // src: require('@/assets/images/chapter-5_slice-5_visual-4.jpg')
          },
          thumbnail: {
            alt: "chapter-5.slice-5.image-4.thumbnail.alt",
            src: "chapter-5.slice-5.image-4.thumbnail.src",
            // src: require('@/assets/images/chapter-5_slice-5_visual-4.jpg')
          },
          video: {
            mp4: require('@/assets/videos/chapter-5_slice-5_visual-4.mp4'),
            webm: require('@/assets/videos/chapter-5_slice-5_visual-4.webm'),
          }
        }
      ]
    }
  },
  {
    component: "NextChapter",
    data: {
      image: {
        alt: "chapter-5.next.image.alt",
        src: "chapter-5.next.image.src",
        // src: require('@/assets/images/chapter-5_next.jpg')
      },
      nextChapter: "chapter-5.next.title"
    }
  }
]